module.exports = __webpack_public_path__ + "img/Multilingual-article.0dd8a838.png";